<div class="flex flex-col justify-center items-center h-[40vh]">
    <h1 class="pb-4 text-4xl">PAGE NOT FOUND</h1>
    <div>
        <button mat-button mat-flat-button color="accent" routerLink="/">Go Home</button>
    </div>
</div>